// extracted by mini-css-extract-plugin
module.exports = {"swiper":"TimelineTopPageSwiper_swiper__2m5RN","swiperContainer":"TimelineTopPageSwiper_swiperContainer__3iO04","slidePage":"TimelineTopPageSwiper_slidePage__1x2yx"};